export var parseIframePostMessageData = function parseIframePostMessageData(data) {
  var jsonData = void 0;

  try {
    jsonData = JSON.parse(data);
  } catch (e) {
    jsonData = null;
  }

  return jsonData;
};
export var handleQuotePostMessage = function handleQuotePostMessage(eData) {
  var _jsonData, _jsonData2;

  var jsonData = {};

  try {
    jsonData = JSON.parse(eData === null || eData === void 0 ? void 0 : eData.data);
  } catch (e) {}

  if ((_jsonData = jsonData) !== null && _jsonData !== void 0 && _jsonData.openUrl && (_jsonData2 = jsonData) !== null && _jsonData2 !== void 0 && _jsonData2.url) {
    var _jsonData3;

    window.open((_jsonData3 = jsonData) === null || _jsonData3 === void 0 ? void 0 : _jsonData3.url, '_blank');
  }
};